module.exports = __webpack_public_path__ + "assets/img/thumb-AstonRx-Program-Video.aef29ddd.webp";